import { render, staticRenderFns } from "./r-reward-bunch-table.vue?vue&type=template&id=a6ae3dda"
import script from "./r-reward-bunch-table.vue?vue&type=script&lang=js"
export * from "./r-reward-bunch-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ae3dda')) {
      api.createRecord('a6ae3dda', component.options)
    } else {
      api.reload('a6ae3dda', component.options)
    }
    module.hot.accept("./r-reward-bunch-table.vue?vue&type=template&id=a6ae3dda", function () {
      api.rerender('a6ae3dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward/r-reward-bunch-table.vue"
export default component.exports